import { useState } from 'react';
import { Alert,Row,Col, Button,Modal,Form, Badge} from 'react-bootstrap';
import axios from '../../../libs/axios'
import useInventoryStore from '../stores/InventoryStore'
import InventoryForm from '../components/InventoryForm';

export default function EditModal({id}) {
    const apiUrl = process.env.REACT_APP_BACKEND_URL
    const store = useInventoryStore()
    const errors = store.errors

    const [show, setShow] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const [renderedComponent, setRenderedComponent] = useState(<InventoryForm />)

    const handleClose = () => { 
      setShow(false);
      useInventoryStore.setState({readonly:false})
    }

    const setInventoryValues = (data) => {
      const valueMappings = {
        'vendor': 'vendor',
        'email': 'email',
        'phone': 'phone',
        'item': 'item',
        'model': 'model',
        'total': 'total',
        'date_start': 'date_start',
        'date_end': 'date_end',
        'created_at': 'created_at',
        'received_on': 'received_on',
        'contract_name': 'contract_name',
        'contract_value': 'contract_value',
        'contract_number': 'contract_number',
        'contract_pic': 'contract_pic',
        'contract_owner': 'contract_owner',
        'category_id': 'category_id',
      };
    
      for (const key in valueMappings) {
        if (data.inventory.hasOwnProperty(key)) {
          store.setValue(valueMappings[key], data.inventory[key]);
        }
      }
    }
    
    const handleShow = () => {
      useInventoryStore.getState().emptyData()
      setRenderedComponent(<InventoryForm />)
      setShow(true);
      setIsLoading(true)

      //axios(`${store.show_url}/${id}`)
      axios(`${apiUrl}/admin/inventories/${id}`)
      .then( response => {
        setInventoryValues(response.data);
        setIsLoading(false)
      })
      .catch( error => {
        if(error.response.status === 422){
          useInventoryStore.setState({ errors :error.response.data.errors })  
        }
        console.warn(error)
        setIsLoading(false)
      })
    }

    const handleCloseClick = () => {
      useInventoryStore.getState().emptyData()
      setRenderedComponent()
      handleClose()
    }

    const handleSubmitClick = () => {

      setIsLoading(true)
      const formData = new FormData()

      const fields = [
        'acknowledge',
        'vendor', 'email', 'phone', 'model', 'category_id',
        'total',
        'date_start', 'date_end', 'received_on',
        'contract_name', 'contract_value', 'contract_number',
        'contract_pic', 'contract_owner',
      ]

      fields.forEach(field => {
        const value = store.getValue(field)
        if (value != null) formData.append(field, value)
      })

      formData.append('_method', 'put');

      axios({
        //'url' : `${store.edit_url}/${id}`,
        'url' : `${apiUrl}/admin/inventories/${id}`,
        'method' : 'post',
        'data' : formData
      })
      .then( response => {
        
        console.log(response)
        setRenderedComponent(<SuccessMessage message={response.data.message} />)

        // Add a delay of 1 second before closing
        setTimeout(() => {
          setIsLoading(false)
          useInventoryStore.setState({ refresh: true })
          handleCloseClick();
        }, 1000);

      })
      .catch( error => {
        setIsLoading(false)
        console.warn(error)
        if(error.response.status === 422){
          useInventoryStore.setState({ errors :error.response.data.errors })  
        }
      })

    }
    const SuccessMessage = ({message='success'}) => {
      return (
        <Alert variant={'success'}>
          {message}
        </Alert>
      )
    }
  

    return (
      <>
        <Button variant="primary" size="sm" onClick={handleShow}>
         Edit
        </Button>
  
        <Modal size={'xl'} show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title><Badge>Edit ID:{id}</Badge></Modal.Title>
          </Modal.Header>
          <Modal.Body>
           {renderedComponent}
          </Modal.Body>
          <Modal.Footer>
            <Form.Check
              className='me-auto'
              isInvalid={errors?.hasOwnProperty('acknowledge')}
              reverse
              label="Saya telah mengesahkan data ini"
              type="checkbox"
              onClick={ () => store.setValue('errors', null) }
              onChange={ (e) => store.setValue('acknowledge', true) }
            />
            <Button variant="secondary" size="sm" onClick={handleCloseClick}>
              Tutup
            </Button>
            <Button variant="primary" size="sm" onClick={handleSubmitClick} disabled={isLoading}>
              Kemaskini
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }



